import { useMemo } from "react";

import { type ChipItem, LimitedChipItems } from "app/pages/sales-intelligence/common-components/filters-panel";
import { FilterResultContainer } from "app/pages/sales-intelligence/common-components/filters-panel/components/styles";
import type { IFilterViewBaseProps } from "app/pages/sales-intelligence/modules/advanced-search-filtering/types/filterInstance";

import { MAX_CHIPS_GROUP_AMOUNT } from "../../../constants";
import type SiteTagsFilterModel from "../../../models/SiteTagsFilter/SiteTagsFilterModel";
import { SiteTagsFilterValue } from "../../../models/SiteTagsFilter/SiteTagsFilterValue";
import leadsSearchFiltersTrackingService from "../../../services/tracking/trackingService";

import { createChip } from "./utils";

const SiteTagsFilterResult = ({
    value,
    isExpanded,
    isActionEnabled = true,
    onGetLifecycleStatus,
    onFilterUpdate,
    onFilterValueRemove,
}: IFilterViewBaseProps<SiteTagsFilterModel>) => {
    const filterValue = useMemo(() => new SiteTagsFilterValue(value), [value]);
    const values = filterValue.values;

    const chipItems: readonly ChipItem[] = useMemo(
        () => values.map((tag) => createChip(tag, onGetLifecycleStatus)),
        [values, onGetLifecycleStatus],
    );

    if (!chipItems.length) {
        return null;
    }

    const handleDelete = (_: string, item: ChipItem): void => {
        const newValue = filterValue.with({ values: values.filter((tag) => tag !== item.id) });

        leadsSearchFiltersTrackingService.filters.trackSiteTagsValueDelete(item.id);
        onFilterUpdate(newValue);
        onFilterValueRemove?.(newValue);
    };

    return (
        <FilterResultContainer>
            <LimitedChipItems
                items={chipItems}
                maxItems={MAX_CHIPS_GROUP_AMOUNT}
                hideActionButton={!isActionEnabled}
                isTabExpanded={isExpanded}
                onDelete={handleDelete}
            />
        </FilterResultContainer>
    );
};

export default SiteTagsFilterResult;
